import { createFeature, createReducer, on } from '@ngrx/store';

import * as fromShared from '../../chats/shared';
import * as fromChats from '../../chats/store/chats.actions';
import { LayoutActions } from './layout.actions';

export const layoutFeatureKey = 'layout';

export enum ViewMode {
  CONVERSATION = 'conversation',
  DOC_VIEWER_CONVERSATION = 'doc-viewer-conversation',
  DOC_VIEWER_ASSISTANT_PROFILE = 'doc-viewer-assistant-profile',
}

export interface LayoutState {
  isMobile: boolean;
  viewMode: `${ViewMode}`;
}

const initialLayoutState: LayoutState = {
  isMobile: false,
  viewMode: 'conversation',
};

export const layoutFeature = createFeature({
  name: layoutFeatureKey,
  reducer: createReducer(
    initialLayoutState,
    on(LayoutActions.setIsMobile, (state, { isMobile }) => ({
      ...state,
      isMobile,
    })),
    on(
      LayoutActions.setViewMode,
      (state, { viewMode }: { viewMode: `${ViewMode}` }) => ({
        ...state,
        viewMode,
      }),
    ),
    /**
     * Handle document viewer actions
     */
    on(
      fromShared.DocumentViewerActions.openDocumentFromChatMessage,
      (state) => ({
        ...state,
        viewMode: 'doc-viewer-conversation',
      }),
    ),
    on(
      fromShared.DocumentViewerActions.openDocumentFromAssistantProfile,
      (state) => ({
        ...state,
        viewMode: 'doc-viewer-assistant-profile',
      }),
    ),
    on(
      fromShared.DocumentViewerActions.closeDocumentViewer,
      fromShared.DocumentViewerActions
        .closeDocumentViewerAndOpenAssistantProfile,
      (state) => ({
        ...state,
        viewMode: 'conversation',
      }),
    ),
    on(
      fromShared.DocumentViewerActions
        .toggleAssistantProfileAndConversationViewMode,
      (state) => ({
        ...state,
        viewMode:
          state.viewMode === 'doc-viewer-conversation'
            ? 'doc-viewer-assistant-profile'
            : 'doc-viewer-conversation',
      }),
    ),
    /**
     * Handle Chats actions
     */
    on(
      fromChats.ChatActions.selectChat,
      fromChats.ChatActions.selectEmptyChat,
      (state) => ({
        ...state,
        viewMode: 'conversation',
      }),
    ),
  ),
});
